/* EB variant guard — LIVE + Funnel Build fix pass 3 (2026-10-21, owner).
   Product page: if the shopper hits Add to Cart with an option still
   unselected, the theme used to submit anyway and Shopify answered with a
   raw "Required parameter missing or invalid: items" error, leaving the
   shopper hanging. This guard runs in the capture phase, before the
   theme's own add handler: when a selection is missing it stops the add,
   highlights exactly which option needs picking, and shows a plain
   prompt ("Please select a Size"). Highlights clear live as the shopper
   makes each pick. */
(function () {
  'use strict';

  function friendly(name) {
    name = (name || '').replace(/\s+/g, ' ').replace(/:\s*$/, '').trim();
    if (/size/i.test(name)) return 'Size';
    if (/colou?r/i.test(name)) return 'Color';
    if (/style/i.test(name)) return 'Style';
    if (/quantity/i.test(name)) return 'Quantity';
    name = name.replace(/^Select Your\s+/i, '').replace(/^Select\s+/i, '');
    return name || 'option';
  }

  function groupsOf(wrap) {
    var groups = [];
    var swatches = wrap.querySelectorAll('.swatch[data-option-index]');
    if (swatches.length) {
      swatches.forEach(function (sw) {
        var idx = sw.getAttribute('data-option-index');
        var picked = !!wrap.querySelector('input[type="radio"][name="option-' + idx + '"]:checked');
        var title = sw.querySelector('.option-title');
        groups.push({ el: sw, picked: picked, name: friendly(title ? title.textContent : '') });
      });
      return groups;
    }
    var wrappers = wrap.querySelectorAll('.selector-wrapper');
    wrappers.forEach(function (w) {
      var sel = w.querySelector('select');
      if (!sel) return;
      var label = w.querySelector('label');
      groups.push({ el: w, picked: !!sel.value, name: friendly(label ? label.textContent : '') });
    });
    return groups;
  }

  function masterPicked(wrap) {
    var m = wrap.querySelector('select[name="id"][data-variant-selector]');
    if (m) return !!m.value;
    var h = wrap.querySelector('input[type="hidden"][name="id"]');
    return h ? !!h.value : true;
  }

  function check(wrap, showPrompt) {
    var groups = groupsOf(wrap);
    var missing;
    if (groups.length) {
      missing = groups.filter(function (g) { return !g.picked; });
    } else {
      missing = masterPicked(wrap) ? [] : [{ el: wrap, name: 'option' }];
    }
    groups.forEach(function (g) {
      g.el.classList.toggle('eb-needs-pick', showPrompt && !g.picked);
    });
    var warn = wrap.querySelector('[data-eb-select-warning]');
    if (warn) {
      if (showPrompt && missing.length) {
        var names = missing.map(function (g) { return g.name; });
        warn.textContent = 'Please select a ' + names.join(' and ') + ' before adding to cart.';
        warn.hidden = false;
      } else if (!missing.length) {
        warn.hidden = true;
        warn.textContent = '';
      }
    }
    return missing;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-add-to-cart-trigger]') : null;
    if (!btn) return;
    var wrap = btn.closest('[data-product-form]');
    if (!wrap) return;
    var missing = check(wrap, true);
    if (missing.length) {
      e.preventDefault();
      e.stopPropagation();
      var first = missing[0].el;
      if (first && first.scrollIntoView) {
        first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }, true);

  document.addEventListener('change', function (e) {
    var wrap = e.target.closest ? e.target.closest('[data-product-form]') : null;
    if (!wrap) return;
    var warn = wrap.querySelector('[data-eb-select-warning]');
    if (warn && !warn.hidden) check(wrap, true);
    else check(wrap, false);
  });
})();
